import React, { useEffect, useState } from "react";
import { api } from "../api/client";
import { Link } from "react-router-dom";

type NewsItem = {
  id: number;
  title: string;
  content_md: string;
  created_at: string;
};

export const NewsListPage: React.FC = () => {
  const [items, setItems] = useState<NewsItem[]>([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  const loadPage = async (reset = false) => {
    if (loading) return;
    setLoading(true);
    try {
      const res = await api.get("/news", {
        params: {
          page: reset ? 1 : page,
          limit: 10,
          search: search || undefined,
        },
      });
      const newItems = res.data.items as NewsItem[];
      if (reset) {
        setItems(newItems);
        setPage(2);
      } else {
        setItems((prev) => [...prev, ...newItems]);
        setPage((p) => p + 1);
      }
      setHasMore(newItems.length > 0);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPage(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSearchSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setPage(1);
    loadPage(true);
  };

  return (
    <div className="page-news">
      <h1>News</h1>
      <form onSubmit={onSearchSubmit} className="news-search-form">
        <input
          type="text"
          placeholder="Suche nach Stichwort..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button type="submit">Suche</button>
      </form>

      {items.map((n) => (
        <article key={n.id} className="news-item">
          <h2>
            <Link to={`/news/${n.id}`}>{n.title}</Link>
          </h2>
          <p className="news-meta">
            {new Date(n.created_at).toLocaleString("de-DE")}
          </p>
        </article>
      ))}

      {hasMore && (
        <button onClick={() => loadPage()} disabled={loading}>
          {loading ? "Lade..." : "Mehr laden"}
        </button>
      )}

      {!hasMore && items.length > 0 && (
        <p style={{ marginTop: "1rem" }}>Keine weiteren News.</p>
      )}

      {items.length === 0 && !loading && (
        <p>Keine News gefunden.</p>
      )}
    </div>
  );
};
